// Product data for Swaadanna
export const products = [
  {
    id: 1,
    name: "Pahari Galgal Pickle",
    description: "Traditional Himalayan galgal (hill lemon) pickle, sun-dried and handcrafted using age-old recipes from the mountains.",
    weight: "350g",
    price: 299,
    category: "Pickle",
    image: "/images/products/pahari-galgal-pickle.png",
    features: ["Sun-dried", "No preservatives", "Traditional recipe"]
  },
  {
    id: 2,
    name: "Chukh Pickle",
    description: "Spicy Himalayan chilli pickle made using traditional pahadi recipes. A fiery delight for those who love bold flavors.",
    weight: "350g",
    price: 299,
    category: "Pickle",
    image: "/images/products/chukh-pickle.png",
    features: ["Extra spicy", "Authentic taste", "Handmade"]
  },
  {
    id: 3,
    name: "Kesar Honey",
    description: "Pure honey infused with premium kesar (saffron), known for its anti-inflammatory benefits and rich golden color.",
    weight: "500g",
    price: 599,
    category: "Honey",
    image: "/images/products/kesar-honey.png",
    features: ["Pure honey", "Kesar infused", "Health benefits"]
  },
  {
    id: 4,
    name: "Pahari Garlic Pickle",
    description: "Strong-flavoured garlic pickle prepared using traditional hill spices. A perfect accompaniment to any meal.",
    weight: "350g",
    price: 299,
    category: "Pickle",
    image: "/images/products/pahari-garlic-pickle.png",
    features: ["Garlic rich", "Mountain spices", "Traditional"]
  },
  {
    id: 5,
    name: "Ground Turmeric",
    description: "Pure, high-curcumin ground turmeric sourced from the pristine Himalayan foothills. Sun-dried and processed traditionally to retain its natural oils and medicinal properties.",
    weight: "250g",
    price: 249,
    category: "Spices",
    image: "/images/products/ground-turmeric.png",
    features: ["Pristine hills sourced", "High curcumin", "No additives"]
  },
  {
    id: 6,
    name: "Nimbu Khatta Mitha Pickle",
    description: "Traditional sweet and sour hill lemon pickle, matured in sunlight using natural sweeteners and mountain spices. A perfect balance of tanginess and sweetness.",
    weight: "350g",
    price: 299,
    category: "Pickle",
    image: "/images/products/nimbu-khatta-mitha-pickle.png",
    features: ["Sun-matured", "Sweet & sour", "Traditional Pahadi"]
  },
  {
    id: 7,
    name: "Papaya Chutney",
    description: "Unique Himalayan papaya chutney crafted with sun-ripened papayas and a blend of aromatic hill spices. A delightful sweet and tangy accompaniment to any meal.",
    weight: "350g",
    price: 279,
    category: "Chutney",
    image: "/images/products/papaya-chutney.png",
    features: ["Aromatic spices", "Handmade", "Traditional recipe"]
  },


];

// Why Choose Us features
export const features = [
  {
    icon: "fa-solid fa-hand-sparkles",
    title: "Handmade with Love",
    description: "Every jar is crafted by hand using traditional methods passed down through generations."
  },
  {
    icon: "fa-solid fa-leaf",
    title: "No Preservatives",
    description: "100% natural ingredients with no artificial preservatives or additives."
  },
  {
    icon: "fa-solid fa-scroll",
    title: "Traditional Recipes",
    description: "Authentic Pahadi recipes that have been perfected over centuries."
  },
  {
    icon: "fa-solid fa-mountain",
    title: "From the Himalayas",
    description: "Sourced from the pristine hills of Himachal Pradesh with pure, organic ingredients."
  }
];

// Testimonials
export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Delhi",
    text: "The Galgal pickle reminds me of my grandmother's recipe. Absolutely authentic taste!",
    rating: 5
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    location: "Mumbai",
    text: "Best pahadi pickles I've ever had. The Chukh pickle is incredibly flavorful!",
    rating: 5
  },
  {
    id: 3,
    name: "Anita Negi",
    location: "Dehradun",
    text: "Finally found pickles that taste like home. The Kesar honey is pure gold!",
    rating: 5
  }
];
